import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Grid, useMediaQuery } from '@mui/material';
import queryString from 'query-string';
import NewsAndEvents from './NewsAndEvents';
import MyBoards from './MyBoards';
import UpcomingBoardMeetings from './UpcomingBoardMeetings';
import ACSnackbar from '../../components/ACSnackbar';
import LinkedInPostModal from '../../components/LinkedInPostModal';
import { useAccount } from '../../contexts/Account';
import BoardsAndInvitations from './BoardsAndInvitations';
import BoardroomHeader from './BoardroomHeader';
import eventBus, { eventBusValues } from '../../eventBus';
import Treatment from '../../components/Treatment';
import { featureFlags } from '../../splitSetup';

const Dashboard = () => {
  const { currentUserInfo, accountDetails, isFreemium } = useAccount();
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const location = useLocation();
  const currentPath = location.pathname;
  const queryParams = new URLSearchParams(location.search);

  // Estados para los snackbars y el modal de LinkedIn
  const [successSnackbar, setSuccessSnackbar] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    let conversationId = queryParams.get('conversationId');
    if (conversationId || currentPath.includes('/messages')) {
      eventBus.dispatch(eventBusValues.triggerConversationDrawerV2, {
        conversationId,
      });
    }
  }, []);

  return (
    <Box
      sx={{
        padding: { xxs: '12px 15px', sm: '24px 30px' },
        width: isSM ? '100%' : null,
      }}
    >
      <ACSnackbar
        open={successSnackbar}
        text={successMessage}
        severity="success"
        onClose={() => setSuccessSnackbar(false)}
        autoHideDuration={6000}
        style={{ marginTop: isFreemium ? '50px' : '0px' }}
      />
      <ACSnackbar
        open={errorSnackbar}
        text={errorMessage}
        severity="error"
        onClose={() => setErrorSnackbar(false)}
        autoHideDuration={6000}
        style={{ marginTop: isFreemium ? '50px' : '0px' }}
      />

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={8}
          sx={{
            width: isSM ? '100%' : null,
          }}
        >
          {/* <Box sx={{ marginBottom: '20px' }}>
            <Typography
              sx={{
                fontWeight: '600',
                fontSize: { xxs: 32, sm: 40 },
                lineHeight: isWrapped ? '25px' : 'inherit',
              }}
            >
              Welcome,{' '}
              <span style={{ color: '#2C71F6' }}>
                {accountDetails.givenName}.&nbsp;
              </span>
              {!isXs ? (
                <span
                  style={{
                    fontWeight: '400',
                    color: '#4D586E',
                    fontSize: 20,
                  }}
                >
                  Here's your dashboard for your boards.
                </span>
              ) : null}
            </Typography>
            {isXs && (
              <Typography
                sx={{ fontWeight: '400', color: '#4D586E', fontSize: 16 }}
              >
                Here's your dashboard for your boards.
              </Typography>
            )}
          </Box> */}
          <BoardroomHeader
            setSuccessMessage={setSuccessMessage}
            setSuccessSnackbar={setSuccessSnackbar}
            advisor={accountDetails}
          />
          {/* <NewsAndEvents /> */}
          <BoardsAndInvitations />
        </Grid>
        <Grid
          item
          xs={12}
          sm={4}
          sx={{
            width: isSM ? '100%' : null,
          }}
        >
          <Treatment
            userId={currentUserInfo?.username || 'not_id'}
            splitNames={featureFlags.key_upcoming_dates}
            updateOnSdkTimedout
            evaluatedComponent={<UpcomingBoardMeetings />}
            conditionFlag
            conditionFailedComponent={<UpcomingBoardMeetings legacy />}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
